<template>
  <main class="minor-layout">
    <title-header/>
    <router-view></router-view>
  </main>
</template>
<script>
import TitleHeader from '@/widgets/TitleHeader'
export default {
  components: {
    TitleHeader
  }
}
</script>
